import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataGridComponent } from './data-grid.component';

@NgModule({
  declarations: [DataGridComponent],
  imports: [CommonModule, FormsModule],
  exports: [DataGridComponent],
})
export class DataGridModule {}
